import '@babel/polyfill';
import 'whatwg-fetch';
import * as Util from './Util.js';

export async function createSharedWheel(copyable, wheelConfig, idToken) {
  const shareMode = copyable ? 'copyable' : 'spin-only';
  const wc = Util.standardizeWheelConfig(wheelConfig.getValues());
  const payload = {
    title: wc.title,
    description: wc.description,
    wheelConfigs: [wc],
    shareMode
  };
  const url = '/api/v3/wheels';
  const respObj = await callServer('POST', url, idToken, payload);
  return respObj.data.path;
}

export async function getSharedWheel(path) {
  const url = `/api/v3/wheels/${path}`;
  const respObj = await callServer('GET', url);
  const retVal = respObj.data;
  retVal.wheelConfig = retVal.wheelConfigs[0];
  delete retVal.wheelConfigs;
  return retVal;
}

export async function getSavedWheel(idToken, path) {
  const url = `/api/v3/wheels/${path}`;
  const respObj = await callServer('GET', url, idToken);
  const retVal = respObj.data;
  retVal.wheelConfig = retVal.wheelConfigs[0];
  delete retVal.wheelConfigs;
  return retVal;
}

export async function getSharedWheels(idToken) {
  const url = '/api/v3/wheels/shared';
  const respObj = await callServer('GET', url, idToken);
  return respObj.data.wheels.map(w => {
    w.config = w.wheelConfigs[0];
    delete w.wheelConfigs;
    return w;
  });
}

export async function deleteSharedWheel(idToken, path) {
  await callServer('DELETE', `/api/v3/wheels/${path}`, idToken);
}

export async function convertAccount(oldIdToken, newIdToken) {
  if (oldIdToken && newIdToken) {
    const url = '/api/v3/wheels/change-owner';
    await callServer('POST', url, newIdToken, { oldIdToken });
  }
}

export async function deleteAccount(idToken) {
  await callServer('DELETE', '/api/v3/users', idToken);
}

export async function getSpinStats() {
  const res = await callServer('GET', '/api/v3/client-settings');
  return res.data;
}

export async function getSavedWheels(idToken, fields) {
  let url = '/api/v3/wheels/private';
  if (fields && fields.length>0) {
    url += `?fields=${fields.replace(/wheelConfig\.title/g, 'title')}`;
  }
  const respObj = await callServer('GET', url, idToken);
  const retVal = respObj.data.wheels.map(w => {
    if (fields?.includes('title')) {
      w.config = { title: w.title };
      delete w.title;
    }
    return w;
  });
  return retVal;
}

export async function deleteWheel(idToken, path) {
  await callServer('DELETE', `/api/v3/wheels/${path}`, idToken);
}

export async function saveWheel(idToken, wheelConfig) {
  const url = '/api/v3/wheels/private';
  const wc = Util.standardizeWheelConfig(wheelConfig);
  const payload = {
    title: wc.title,
    description: wc.description,
    wheelConfigs: [wc]
  };
  const respObj = await callServer('PUT', url, idToken, payload);
  return respObj.data.path;
}

async function callServer(method, urlPath, idToken, payload) {
  const request = { method, mode: 'cors', headers: {} };
  if (idToken) {
    request.headers['Authorization'] = idToken;
  }
  if (payload) {
    request.headers['Content-Type'] = 'application/json';
    request.body = JSON.stringify(payload);
  }
  const response = await fetch(Util.getApiUrl(urlPath), request);
  const respObj = await parseResponse(response);
  return respObj;
}

async function parseResponse(response) {
  const respText = await response.text();
  if (respText.startsWith('<')) throw respText;
  const respObj = JSON.parse(respText);
  if (respObj.hasOwnProperty('error')) throw respObj.error;
  return respObj;
}
